
import $ from 'jquery';
import { Freewall } from 'freewall';
import 'justifiedGallery/dist/js/jquery.justifiedGallery';
import 'justifiedGallery/dist/css/justifiedGallery.css';

export function createMosiac(selector, loadingSelector) {
  const wall = new Freewall(selector)
  wall.reset({
    selector: '.item',
    animate: true,
    cellW: 100,
    cellH: 'auto',
    gutterX: 2,
    gutterY: 2,
    onResize() {
      wall.fitWidth();
    },
  })

  $(window).load(() => {
    $(loadingSelector).remove()
    $(selector).show()
    wall.fitWidth()
  })

  return wall;
}

export function createRowMosiac(selector) {
  return $(selector).justifiedGallery({
    rowHeight: 200,
    lastRow: 'nojustify',
    margins: 2,
  })
}



// WEBPACK FOOTER //
// ./src/frontend/gallery/index.js